import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatButtonToggleChange} from "@angular/material/button-toggle";
import { StartupContactModel } from 'app/models/contact-form/startup-contact.model';
import {Subject} from 'rxjs';
import {takeUntil} from "rxjs/operators";
import {NebulaMediaWatcherService} from "../../../../../../@scientifica-cms-fe/services/media-watcher";
import {batchList} from "../../../../batch-list";

@Component({
    selector: 'app-ssdf-call-batch-detail-dashboard',
    templateUrl: './ssdf-call-batch-detail-dashboard.component.html',
    styleUrls: ['./ssdf-call-batch-detail-dashboard.component.scss']
})
export class SsdfCallBatchDetailDashboardComponent implements OnInit {

    @Input() selectedDashboardView: string;
    @Input() selectedDateFilter: string;
    @Input() filterDates: any;
    @Input() fundingNeedPieData: any;
    @Input() originationData: any;
    @Input() appForTrl: any;
    @Input() appForRegion: any;
    @Input() appForDay: any;
    @Input() generalData: any;
    @Input() patentsData: any;
    @Input() formedCompanyData: any;
    @Input() zoneData: any;
    @Input() labNeededData: any;
    @Input() selectedBatchId = 2;
    @Input() appForPremoney: any;
    @Input() countryData: any;
    @Input() applicationList : StartupContactModel[]


    @Output() onChangeDateFilterState = new EventEmitter<any>();
    @Output() onChangeDashboardView = new EventEmitter<any>();
    @Output() onFilterByBatch = new EventEmitter<any>();
    drawerMode: 'over' | 'side' = 'side';
    drawerOpened: boolean = true;

    batchList = batchList;

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(private _mediaWatcherService: NebulaMediaWatcherService,
                private _changeDetectorRef : ChangeDetectorRef) {
    }

    ngOnInit(): void {
        this._mediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((res) => {
                const isScreenSmall = res.breakpoints ?
                    res.breakpoints['(max-width: 550px)'] : false;
                // Set the drawerMode and drawerOpened if the given breakpoint is active
                if (!isScreenSmall) {
                    this.drawerMode = 'side';
                    this.drawerOpened = true;
                } else {
                    this.drawerMode = 'over';
                    this.drawerOpened = false;
                }


                // Mark for check
                this._changeDetectorRef.markForCheck();
            });
    }

    filterByBatch(batchId: number) {
        this.onFilterByBatch.emit(batchId)
    }

    changeDateFilterState($event: MatButtonToggleChange) {
        this.onChangeDateFilterState.emit($event);
    }

    changeDashboardView(view: string) {
        this.onChangeDashboardView.emit(view);
    }
}
